export default "__VITE_ASSET__437935a0__"